<template>
  <div
    class="flex justify-center items-center px-20 md:px-0 text-app-color"
    :class="[
      isDarkMode ? 'bg-sidebar' : 'bg-green-51',
      isMobile ? 'h-150 fixed z-50' : 'h-50 relative'
    ]"
  >
    <div class="flex items-start md:items-center" :class="{ 'flex-col': isMobile }">
      <p class="truncate text-15 flex items-center flex-wrap md:flex-no-wrap">
        <span class="mr-5">Get</span>
        <span class="font-semibold mr-5">unlimited</span>
        <span class="italic mr-5">spaces, pages </span>and
        <span class="italic ml-5 mr-5">storage space </span>
        <span class="mr-5">for just</span>
        <span class="font-semibold text-app-color">$4 a month.</span>
      </p>

      <div class="flex items-center font-semibold text-15 ml-5 group cursor-pointer" @click="upgradeToPro">
        <span>Upgrade now</span>
        <i class="icon-arrow-right1 text-16 font-bold relative top-1 left-5 group-hover:left-15 transition-position duration-300" />
      </div>
    </div>

    <ButtonModule
      has-hover
      prefix="icon-close"
      class="text-16 absolute right-0 top-0 mt-19 md:mt-12 mr-10"
      button-opacity="40"
      @click="closeModal"
    />
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

import { profileService } from '@/services'

export default {
  components: { ButtonModule },

  emits: ['hide'],

  computed: {
    ...mapGetters(['isDarkMode', 'isMobile']),
    ...mapState({
      user: state => state.profile.user
    })
  },

  methods: {
    ...mapActions(['getProfile']),
    ...mapMutations(['loading', 'setNotification', 'changeActiveState', 'toggleSettingsModal', 'toggleAside']),

    async closeModal () {
      await profileService.update({
        email: this.user.email,
        firstName: this.user.profile.firstName,
        lastName: this.user.profile.lastName,
        showUpgradeToPro: this.user.profile.showUpgradeToPro + 1
      })
      this.$emit('hide')
      await this.getProfile()
    },

    upgradeToPro () {
      if (this.isMobile) {
        this.toggleAside(false)
      }
      this.changeActiveState('Plans')
      this.toggleSettingsModal(true)
    }
  }
}
</script>
